import { useMemo } from 'react';
import Select from '../DefaultSelect';
import { TSelectProps } from '../index';
import { mergeSX } from '../../../services/helpers';
import { AB2, S1 } from '../../../theme';
import { TYPOGRAPHY_BODY2 } from '../../Typography';
import CaretIcon from '../../../icons/CaretIcon';

const buildSX = () => ({
  '& .MuiOutlinedInput-input': {
    display: 'flex',
    alignItems: 'center',
  },
  '&.MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: '40px',
    color: S1,
    '&:hover': {
      backgroundColor: AB2,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    color: S1,
  },
  '& .MuiSelect-icon': {
    color: S1,
    top: '20%',
  },
  '& .MuiSelect-select': {
    ...TYPOGRAPHY_BODY2,
    paddingLeft: '16px',
  },
});

const SideMenuSelect = (props: TSelectProps) => {
  const {
    children, sx, disabled, ...restProps
  } = props;
  const IconComponent = useMemo(() => (disabled ? () => null : CaretIcon), [disabled]);
  const inputProps = useMemo(() => ({ readOnly: disabled }), [disabled]);

  return (
    <Select
      sx={mergeSX(buildSX(), sx)}
      IconComponent={IconComponent}
      inputProps={inputProps}
      {...restProps}
    >
      {children}
    </Select>
  );
};

export default SideMenuSelect;
